module.exports = __webpack_public_path__ + "tables/media/Package_filled.bcda2ae6.svg";